import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const HIDE_ON = ["/", "/auth/callback"];

export default function BackButton() {
  const nav = useNavigate();
  const { pathname } = useLocation();

  if (HIDE_ON.includes(pathname)) return null;

  const goBack = () => {
    if (window.history.length > 1) nav(-1);
    else nav("/");
  };

  return (
    <button
      data-testid="back-button"
      onClick={goBack}
      aria-label="Go back"
      className="fixed top-4 left-4 z-[80] inline-flex items-center gap-1.5 rounded-full bg-black/40 backdrop-blur-md border border-white/15 text-white px-3.5 py-2 text-xs uppercase tracking-[0.2em] font-semibold hover:bg-black/60 hover:border-[#C9A961] transition-colors shadow-lg"
    >
      <ArrowLeft className="w-3.5 h-3.5" /> Back
    </button>
  );
}
